import { getColor, transparentize, mode } from '@chakra-ui/theme-tools';
const parts = ['track', 'thumb'];
function baseStyleTrack(props) {
    const { colorScheme, theme } = props;
    const disabledColor = transparentize('gray.300', 0.16)(theme);
    const checkedColor = mode(`${colorScheme}.500`, `${colorScheme}.400`)(props);
    return {
        borderRadius: 'full',
        padding: '2px',
        transition: 'all 120ms',
        bg: mode('gray.300', transparentize('gray.450', 0.8)(theme))(props),
        _checked: {
            bg: checkedColor,
            _disabled: {
                bg: disabledColor,
            },
        },
        _focus: {
            boxShadow: mode(`0 0 0 1px ${getColor(theme, 'blue.600')}, ` +
                `0 0 0 5px ${transparentize('blue.400', 0.24)(theme)}`, `0 0 0 1px ${getColor(theme, 'blue.300')}, ` +
                ` 0 0 0 5px ${transparentize(`blue.400`, 0.24)(theme)}`)(props),
        },
        _disabled: {
            opacity: 1,
            bg: disabledColor,
            cursor: 'not-allowed',
        },
    };
}
const baseStyleThumb = (props) => {
    const { isDisabled } = props;
    return {
        bg: isDisabled ? mode('white', 'gray.400')(props) : 'white',
        transition: 'transform 250ms',
        borderRadius: 'full',
        transform: 'translateX(0)',
    };
};
const baseStyle = (props) => ({
    track: baseStyleTrack(props),
    thumb: baseStyleThumb(props),
});
const sizes = {
    md: {
        track: { w: '2.25rem', h: '1rem' },
        thumb: {
            w: '1rem',
            h: '1rem',
            _checked: {
                transform: 'translateX(1.25rem)',
            },
        },
    },
};
const defaultProps = {
    size: 'md',
    colorScheme: 'blue',
};
export default {
    parts,
    baseStyle,
    sizes,
    defaultProps,
};
//# sourceMappingURL=switch.js.map